export const INIT_STATE = 'INIT_ACTIVITY_LIST_STATE' ;

export const GET_ACTIVITY_LIST_LOADING = 'GET_ACTIVITY_LIST_LOADING';
export const GET_ACTIVITY_LIST_SUCCESS = 'GET_ACTIVITY_LIST_SUCCESS';
export const GET_ACTIVITY_LIST_ERROR = 'GET_ACTIVITY_LIST_ERROR';

export const POST_REVOKE_LOADING = 'POST_REVOKE_LOADING';
export const POST_REVOKE_SUCCESS = 'POST_REVOKE_SUCCESS';
export const POST_REVOKE_ERROR = 'POST_REVOKE_ERROR';
